import AppSocialMedia from "components/atoms/AppSocialMedia"
import { APP_INFO } from "constants/app_info"
import { useLang } from "hooks/useLang"
import Image from "next/image"
import React from "react"
import { AiOutlineLike } from "react-icons/ai"
import { BsWhatsapp } from "react-icons/bs"
import { FiMail, FiPhone } from "react-icons/fi"

const ContactDetails = () => {
    const { t, isAr } = useLang()
    const position = isAr ? "left" : "right"

    return (
        <div className="relative flex h-full flex-1 justify-center pt-10 md:pt-0 mt-4">
            <Image
                src={"/svg/v2/half-sparkle.png"}
                alt="sparkle"
                className={`absolute bottom-0 ${position}-0 hidden md:flex`}
                style={{ objectFit: "contain" }}
                height={200}
                width={200}
            />
            <div className="flex flex-col gap-8">
                <div className="flex gap-2">
                    <FiMail size={25} color="#FD0058" />
                    <div className="flex flex-col gap-2">
                        <span className="text-sm font-bold md:text-base">
                            {t("email_address")}
                        </span>
                        <p className="text-sm md:text-base">{APP_INFO.email}</p>
                    </div>
                </div>
                <div className="flex gap-2">
                    <FiPhone size={25} color="#FD0058" />
                    <div className="flex flex-col gap-2">
                        <span className="text-sm font-bold md:text-base">
                            {t("phone")}
                        </span>
                        <p
                            style={{ direction: "ltr" }}
                            className="text-sm md:text-base"
                        >
                            {APP_INFO.phone}
                        </p>
                    </div>
                </div>
                <div className="flex gap-2">
                    <BsWhatsapp size={25} color="#FD0058" />
                    <div className="flex flex-col gap-2">
                        <span className="text-sm font-bold md:text-base">
                            {t("whatsapp")}
                        </span>
                        <p
                            style={{ direction: "ltr" }}
                            className="text-sm md:text-base"
                        >
                            {APP_INFO.social_media.whatsapp}
                        </p>
                    </div>
                </div>
                <div className="flex gap-2">
                    <AiOutlineLike size={25} color="#FD0058" />
                    <div className="flex flex-col gap-2">
                        <span className="text-sm font-bold md:text-base">
                            {t("follow_us")}
                        </span>
                        <AppSocialMedia gap={12} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactDetails
